export default {
  buttons: {
    signup: 'Sign up',
    login: 'Log in',
  },
};
